export default __webpack_public_path__ + "static/media/Equipe8.91c3dfef.png";